import { createFileRoute, redirect } from "@tanstack/react-router";
import { AdminRoute } from "@/components/admin/AdminRoute";
import { authService } from "@/lib/services";
import { isPlatformStaffRole } from "@/lib/platform-staff";

function AdminRouteGate() {
  const { tab } = Route.useSearch();
  return <AdminRoute tab={tab} />;
}

export const Route = createFileRoute("/admin")({
  // Import estático a propósito: `?tsr-split` y React.lazy dejan el chunk
  // stale en HMR y Chrome tira "Failed to fetch dynamically imported module".
  codeSplitGroupings: [],
  beforeLoad: async () => {
    if (typeof window === "undefined") return;
    const user = await authService.getCurrentUser();
    if (!user || !isPlatformStaffRole(user.role)) {
      throw redirect({ to: "/acceso/comercio", search: { returnTo: "/admin" } });
    }
  },
  component: AdminRouteGate,
  validateSearch: (s: Record<string, unknown>) => ({
    tab: typeof s.tab === "string" ? s.tab : undefined,
  }),
  head: () => ({
    meta: [{ title: "Super Admin — Structura Market" }],
  }),
});
